/* eslint-disable @typescript-eslint/naming-convention */
import 'reflect-metadata';
import {FormElement, FormElementConfiguration} from 'app/entities/form/formElement.entity';
import {FormElementRepeaterView, FormElementType} from 'app/entities/enums';
import {Type} from 'class-transformer';
import {Entity} from 'app/core/main.entity';
import {FormElementText} from 'app/entities/form/formElementText.entity';
import {FormElementTextarea} from 'app/entities/form/formElementTextarea.entity';
import {FormElementSelect} from 'app/entities/form/formElementSelect.entity';
import {FormElementCheckbox} from 'app/entities/form/formElementCheckbox.entity';
import {FormElementData, FormElementDataRange} from 'app/entities/form/formElementDate.entity';
import {FormElementFile} from 'app/entities/form/formElementFile.entity';
import {FormElementGroup} from 'app/entities/form/formElementGroup.entity';
import {FormElementNumber} from 'app/entities/form/formElementNumber.entity';
import {FormElementSegment} from 'app/entities/form/formElementSegment.entity';
import {FormElementToggle} from 'app/entities/form/formElementToggle.entity';
import {FormElementRadio} from 'app/entities/form/formElementRadio.entity';
import {FormElements} from 'app/entities/form/form.entity';
import {FormElementCustomCalendarRepeat} from 'app/entities/form/formElementCustomCalendarRepeat.entity';

export class FormElementRepeater extends FormElement {
  type: FormElementType = 'repeater';

  @Type(() => FormElementRepeaterConfiguration)
  configuration?: FormElementRepeaterConfiguration = new FormElementRepeaterConfiguration();
}

export class FormElementRepeaterConfiguration extends FormElementConfiguration {
  incrementTitle?: string = null;
  addButtonTitle?: string = null;
  view?: FormElementRepeaterView = 'full';

  @Type(() => Entity, {
    discriminator: {
      property: 'type',
      subTypes: [
        {value: FormElementText, name: 'text'},
        {value: FormElementTextarea, name: 'textarea'},
        {value: FormElementSelect, name: 'select'},
        {value: FormElementCheckbox, name: 'checkbox'},
        {value: FormElementData, name: 'date'},
        {value: FormElementDataRange, name: 'dateRange'},
        {value: FormElementFile, name: 'file'},
        {value: FormElementGroup, name: 'group'},
        {value: FormElementNumber, name: 'number'},
        {value: FormElementRepeater, name: 'repeater'},
        {value: FormElementSegment, name: 'segments'},
        {value: FormElementToggle, name: 'toggle'},
        {value: FormElementRadio, name: 'radio'},
        {value: FormElementCustomCalendarRepeat, name: 'calendarRepeat'}
      ],
    },
    keepDiscriminatorProperty: true
  })
  fields: FormElements[] = [];
}

